import React, { Fragment } from 'react';
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import { viewPostal, viewCard } from './Constants'; 

//styles
import './css/Custom.css';

//components
import Header from './components/common/Header';
import Home from './components/home/Home';
import Form from './components/form/Form';
import Card from './components/card/Card';

const App = () => {

    const GetQuery = () => {
        return new URLSearchParams(useLocation().search);
    }
    
    const HandleViews = () => {
    
        const { search } = useLocation();    
        const query = GetQuery();
        const idTarjeta = query.get(viewCard);
        const idPostal = query.get(viewPostal);
    
        if (search.includes(viewPostal)){
            return <Form idPostal={idPostal}/>
        } else if (search.includes(viewCard) && idTarjeta !== ''){
            return <Card idTarjeta={idTarjeta} viewCard={viewCard} />            
        } else {
            return <Home />;
        }
    }

    return (
        <Fragment>
            <Header />
            <Router>
                <HandleViews />                        
            </Router>
        </Fragment>
    )
}

export default App;

